import { Method } from 'axios';
import { Pagination } from 'services/search';

export interface ApiConfig {
  hostname?: string;
  path: string;
  method?: Method;
  headers?: any;
  formData?: any;
  body?: any;
  additionalData?: any;
  params?: any;
  timeout?: number;
  responseType?: 'json' | 'blob' | 'arraybuffer' | 'text';
}

export interface ItemReference {
  id: string;
  number: string;
}

export interface SimpleSnackBarConfig {
  serviceName: any;
}

export interface SnackBarConfigWithMessages {
  getMessage: {
    success?: (response: any) => string;
    error?: (error: any) => string;
  };
}

export type SnackBarConfig = SnackBarConfigWithMessages | SimpleSnackBarConfig;

export interface DataWithPagination<T = any> {
  pagination: Pagination;
  data: T[];
}

export interface AvailabilityResult {
  isAvailable: boolean;
  reasons: string[];
  message: string | null;
}

export const transformAvailabilityResult = (data: any): AvailabilityResult => ({
  isAvailable: data?.isAvailable ?? false,
  reasons: data?.reasons ?? [],
  message: data?.message ?? null,
});
